export const UPDATE_EXCHANGE_RATE = "UPDATE_EXCHANGE_RATE";
